export default "__VITE_ASSET__gNdPUwCn__"